import * as TYPE from './actionType.js';

export function checkoutShipmentData(checkoutShipmentData) {
  return { type: TYPE.DELIVERYDATA, data: checkoutShipmentData };
}
